"use client";

import Chevron from "@/assets/svg/Chevron";
import {
  useCountries,
  useLocation,
  useSetLocation,
} from "@/lib/hooks/useCentra";
import { Select } from "@base-ui-components/react/select";
import clsx from "clsx";
import styles from "./CountrySelector.module.css";

export interface CountrySelectorProps {
  className?: string;
}

const countryMap: Record<string, string> = {
  Norway: "Norge",
  Sweden: "Sverige",
  Denmark: "Danmark",
};

export const CountrySelector = ({ className }: CountrySelectorProps) => {
  const { data: countries, isLoading } = useCountries();
  const { data: location, isLoading: isLoadingLocation } = useLocation();
  const { mutate } = useSetLocation();

  if (isLoading || isLoadingLocation) return null;

  return (
    <div>
      <Select.Root
        defaultValue={location?.country}
        onValueChange={(value) => {
          mutate({ country: value });
        }}
      >
        <Select.Trigger className={clsx(styles.Trigger, className)}>
          <Select.Value>
            {(value) => {
              const country = countries?.find((c) => c.country === value);
              if (country) {
                return (
                  <span>
                    {countryMap[country.name!] || country.country} / (
                    {country.currency})
                  </span>
                );
              }
              return <span>{value}</span>;
            }}
          </Select.Value>
          <Select.Icon className={styles.Icon}>
            <Chevron direction="down" />
          </Select.Icon>
        </Select.Trigger>

        <Select.Portal>
          <Select.Positioner className={styles.Positioner}>
            <Select.Popup className={styles.Popup}>
              <Select.Item className={styles.Item} disabled value={null}>
                <Select.ItemText>Select country</Select.ItemText>
              </Select.Item>
              {countries?.map((country) => (
                <Select.Item
                  className={styles.Item}
                  key={country.country}
                  value={country.country}
                >
                  <Select.ItemText>
                    {country.name} ({country.currency})
                  </Select.ItemText>
                </Select.Item>
              ))}
            </Select.Popup>
          </Select.Positioner>
        </Select.Portal>
      </Select.Root>
    </div>
  );
};
